class jb_discount_stage extends HTMLElement {
  constructor() {
    super();

    this.currentStage = 0;
    this.brandValue = "";
    this.sizeValue = "";
    this.assignedOffer = null;

    this.offers = [];
    this.fakeActivity = [];
    this.products = [];

    this.currency = "USD";
    this.realCheckout = false;
    this.redirectUrl = "/collections/all";

    this.claimsApi =
      this.dataset.claimsApi ||
      "https://offculture-live-claims.vercel.app/api/claims";

    this.liveActivity = [];
    this.activityIndex = 0;
    this.activityInterval = null;
    this.liveRefreshInterval = null;
    this.liveRequestInFlight = false;
    this.timeouts = [];
  }

  connectedCallback() {
    this.loadConfig();
    this.cacheElements();
    this.bindEvents();
    this.initializeActivityFeed();
  }

  disconnectedCallback() {
    if (this.activityInterval) {
      clearInterval(this.activityInterval);
      this.activityInterval = null;
    }

    if (this.liveRefreshInterval) {
      clearInterval(this.liveRefreshInterval);
      this.liveRefreshInterval = null;
    }

    this.clearTimeouts();
  }

  loadConfig() {
    this.currency = this.dataset.currency || "USD";
    this.realCheckout = this.dataset.realCheckout === "true";
    this.redirectUrl = this.dataset.redirectUrl || "/collections/all";
    this.claimsApi =
      this.dataset.claimsApi ||
      "https://offculture-live-claims.vercel.app/api/claims";

    const configId = this.dataset.configId;
    const configScript = configId ? document.getElementById(configId) : null;

    if (!configScript) return;

    try {
      const config = JSON.parse(configScript.textContent);
      this.offers = Array.isArray(config.offers) ? config.offers : [];
      this.fakeActivity = Array.isArray(config.activity) ? config.activity : [];
      this.products = Array.isArray(config.products) ? config.products : [];
    } catch (error) {
      console.error("jb-discount-stage: failed to parse config", error);
    }
  }

  clearTimeouts() {
    this.timeouts.forEach((timeout) => clearTimeout(timeout));
    this.timeouts = [];
  }

  addTimeout(callback, delay) {
    const timeout = setTimeout(() => {
      callback();
      this.timeouts = this.timeouts.filter((t) => t !== timeout);
    }, delay);
    this.timeouts.push(timeout);
    return timeout;
  }

  cacheElements() {
    this.phoneElement = this.querySelector("#jb_phone");
    this.backButton = this.querySelector("#jb_back");
    this.stages = [...this.querySelectorAll(".jb_stage")];
    this.progressBars = [...this.querySelectorAll(".jb_progress_item")];
    this.progressLabel = this.querySelector("#jb_progress_label");

    this.startButton = this.querySelector("#jb_start");
    this.brandInput = this.querySelector("#jb_brand");
    this.sizeSelect = this.querySelector("#jb_size");
    this.valueButton = this.querySelector("#jb_value");
    this.pvBrand = this.querySelector("#jb_pv_brand");
    this.pvSize = this.querySelector("#jb_pv_size");

    this.scanner = this.querySelector("#jb_scanner");
    this.scanLabel = this.querySelector("#jb_scan_label");

    this.reward = this.querySelector("#jb_reward");
    this.rule = this.querySelector("#jb_rule");
    this.outBrand = this.querySelector("#jb_out_brand");
    this.code = this.querySelector("#jb_code");
    this.continueButton = this.querySelector("#jb_continue");

    this.floatLabel = this.querySelector("#jb_float_label");
    this.floatValue = this.querySelector("#jb_float_value");
this.priceElements = [...this.querySelectorAll("[data-jb-price]")];
this.checkoutButtons = [...this.querySelectorAll(".jb_checkout_btn")];
this.ctaCodeElements = [...this.querySelectorAll(".jb_cta_code")];

    this.receiptLabel = this.querySelector("#jb_receipt_label");
    this.receiptCode = this.querySelector("#jb_receipt_code");
    this.receiptValue = this.querySelector("#jb_receipt_value");

    this.toast1 = this.querySelector("#jb_toast1");
    this.tickerContents = [...this.querySelectorAll(".jb_ticker_content")];

    this.checkIds = ["jb_chk1", "jb_chk2", "jb_chk3", "jb_chk4"];
  }

  bindEvents() {
    if (this.backButton) {
      this.backButton.addEventListener("click", this.handleBack.bind(this));
    }

    if (this.startButton) {
      this.startButton.addEventListener("click", this.handleStart.bind(this));
    }

    if (this.brandInput) {
      this.brandInput.addEventListener(
        "input",
        this.updateLabelPreview.bind(this)
      );
    }

    if (this.sizeSelect) {
      this.sizeSelect.addEventListener(
        "change",
        this.updateLabelPreview.bind(this)
      );
    }

    if (this.valueButton) {
      this.valueButton.addEventListener(
        "click",
        this.handleValueClick.bind(this)
      );
    }

    if (this.continueButton) {
      this.continueButton.addEventListener(
        "click",
        this.handleContinue.bind(this)
      );
    }

this.checkoutButtons.forEach((button) => {
  button.addEventListener("click", this.handleCheckout.bind(this));
});
  }

  showStage(index) {
    this.stages.forEach((stage, i) => {
      stage.classList.toggle("jb_active", i === index);
    });

    this.currentStage = index;

    if (this.backButton) {
      this.backButton.classList.toggle("jb_hidden", index === 0);
    }

    if (this.progressLabel) {
      this.progressLabel.textContent = `${String(index).padStart(
        2,
        "0"
      )} / 03`;
    }

    this.progressBars.forEach((bar, i) => {
      bar.classList.toggle("jb_active", i <= index);
    });

    const targetElement = this.phoneElement || this;
    targetElement.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }

  handleBack() {
    if (this.currentStage === 0) return;

    if (this.currentStage === 2) {
      this.clearTimeouts();
      if (this.scanner) {
        this.scanner.classList.remove("jb_flash");
      }
      this.showStage(1);
      return;
    }

    if (this.currentStage === 3) {
      this.showStage(1);
      return;
    }

    this.showStage(this.currentStage - 1);
  }

  handleStart() {
    this.showStage(1);
  }

  updateLabelPreview() {
    this.brandValue = this.brandInput
      ? this.brandInput.value.trim().toUpperCase()
      : "";

    this.sizeValue = this.sizeSelect ? this.sizeSelect.value : "";

    if (this.pvBrand) {
      this.pvBrand.textContent = this.brandValue || "YOUR LABEL";
    }

    if (this.pvSize) {
      this.pvSize.textContent = this.sizeValue
        ? `SIZE ${this.sizeValue}`
        : "SIZE —";
    }

    if (this.valueButton) {
      this.valueButton.disabled = !(this.brandValue && this.sizeValue);
    }
  }

  hashString(str) {
    let hash = 0;

    for (let i = 0; i < str.length; i++) {
      hash = (hash << 5) - hash + str.charCodeAt(i);
      hash = hash | 0;
    }

    return Math.abs(hash);
  }

  assignOffer() {
    if (!this.offers.length) {
      this.assignedOffer = null;
      return;
    }

    const offerIndex =
      this.hashString(`${this.brandValue}|${this.sizeValue}`) %
      this.offers.length;

    this.assignedOffer = this.offers[offerIndex];
  }

  handleValueClick() {
    this.assignOffer();
    this.startScanner();
  }

  startScanner() {
    this.clearTimeouts();

    if (this.scanLabel) {
      this.scanLabel.textContent = `${this.brandValue} / ${this.sizeValue}`;
    }

    this.showStage(2);

    this.checkIds.forEach((id) => {
      const element = this.querySelector(`#${id}`);
      if (element) {
        const text = element.textContent.trim().replace("[✓]", "[ ]");
        element.textContent = text;
      }
    });

    this.checkIds.forEach((id, index) => {
      this.addTimeout(() => {
        const element = this.querySelector(`#${id}`);
        if (element) {
          element.textContent = element.textContent.replace("[ ]", "[✓]");
          element.classList.add("jb_text_red");
        }
      }, 430 + index * 420);
    });

    this.addTimeout(() => {
      if (this.scanner) {
        this.scanner.classList.add("jb_flash");
      }

      this.addTimeout(() => {
        if (this.scanner) {
          this.scanner.classList.remove("jb_flash");
        }

        this.updateRewardUI();
        this.showStage(3);
        this.saveCurrentClaim();
      }, 380);
    }, 2300);
  }

  updateRewardUI() {
    if (!this.assignedOffer) return;

    if (this.reward) {
      this.reward.textContent = this.assignedOffer.label;
    }

    if (this.rule) {
      this.rule.textContent = this.assignedOffer.rule;
    }

    if (this.outBrand) {
      this.outBrand.textContent = `${this.brandValue} / ${this.sizeValue}`;
    }

    if (this.code) {
      this.code.textContent = this.assignedOffer.code;
    }

    if (this.floatLabel) {
      this.floatLabel.textContent = `${this.brandValue} / ${this.sizeValue}`;
    }

    if (this.floatValue) {
      this.floatValue.textContent = `-${this.assignedOffer.label}`;
    }

this.ctaCodeElements.forEach((el) => {
  el.textContent = this.assignedOffer.code;
});

    if (this.receiptLabel) {
      this.receiptLabel.textContent = `${this.brandValue} / ${this.sizeValue}`;
    }

    if (this.receiptCode) {
      this.receiptCode.textContent = this.assignedOffer.code;
    }

    if (this.receiptValue) {
      this.receiptValue.textContent = `PAID ${this.assignedOffer.label}`;
    }
  }

  formatMoney(cents) {
    const amount = cents / 100;

    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en", {
        style: "currency",
        currency: this.currency,
      }).format(amount);
    } catch (error) {
      return `$${amount.toFixed(2)}`;
    }
  }

  // Discounted price in cents for a given product (price is already in cents).
  calculatePriceCents(priceCents) {
    if (!this.assignedOffer) return priceCents;

    if (this.assignedOffer.amount_type === "percentage") {
      const fraction = this.assignedOffer.amount / 100;
      return Math.round(priceCents * (1 - fraction));
    }

    const discountCents = Math.round(this.assignedOffer.amount * 100);
    return Math.max(0, priceCents - discountCents);
  }

  handleContinue() {
    this.priceElements.forEach((element) => {
      const index = Number(element.closest("[data-jb-product-index]")?.dataset.jbProductIndex);
      const product = this.products[index];

      if (!product) return;

      const discountedCents = this.calculatePriceCents(product.price);
      element.textContent = this.formatMoney(discountedCents);
    });

    this.showStage(4);
  }

handleCheckout() {
  if (!this.assignedOffer) {
    this.showStage(5);
    return;
  }

  const isFinalStage = this.currentStage === this.stages.length - 1; // Stage 6 (receipt)

  // On the final stage, always send the shopper to real checkout with
  // the code applied — regardless of the "demo receipt" toggle.
  if (this.realCheckout || isFinalStage) {
    const code = encodeURIComponent(this.assignedOffer.code);
    const redirect = encodeURIComponent(this.redirectUrl);
    window.location.href = `/discount/${code}?redirect=${redirect}`;
    return;
  }

  this.showStage(5);
}

  getClaimAmount() {
    if (!this.assignedOffer) return null;

    const label = String(this.assignedOffer.label || "");
    const dollarMatch = label.match(/\$\s*(\d+(?:\.\d+)?)/);

    if (dollarMatch) {
      return Number(dollarMatch[1]);
    }

    if (this.assignedOffer.amount_type !== "percentage") {
      const amount = Number(this.assignedOffer.amount);
      return Number.isFinite(amount) && amount > 0 ? amount : null;
    }

    return null;
  }

  getClaimSessionKey(amount) {
    return `jb_claim_${this.hashString(
      `${this.brandValue}|${this.sizeValue}|${amount}|${this.assignedOffer?.code || ""}`
    )}`;
  }

  async saveCurrentClaim() {
    if (!this.brandValue || !this.sizeValue || !this.assignedOffer) return;

    const amount = this.getClaimAmount();
    if (!Number.isFinite(amount) || amount <= 0) return;

    const sessionKey = this.getClaimSessionKey(amount);

    try {
      if (sessionStorage.getItem(sessionKey) === "1") return;
    } catch (error) {}

    try {
      const response = await fetch(this.claimsApi, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          brand: this.brandValue,
          size: this.sizeValue,
          amount,
        }),
      });

      if (!response.ok) {
        console.warn(
          "jb-discount-stage: could not save live claim",
          response.status
        );
        return;
      }

      const data = await response.json();
      const claim = this.normalizeLiveClaim(data?.claim);

      if (!claim) return;

      try {
        sessionStorage.setItem(sessionKey, "1");
      } catch (error) {}

      this.liveActivity = [
        claim,
        ...this.liveActivity.filter((item) => item.id !== claim.id),
      ].slice(0, 15);

      this.activityIndex = 0;
      this.renderLiveTicker();
      this.renderLiveToast(claim);
    } catch (error) {
      console.warn("jb-discount-stage: live claim service unavailable", error);
    }
  }

  normalizeLiveClaim(claim) {
  if (!claim || typeof claim !== "object") return null;

  const name = String(claim.name || "Someone").trim();
  const brand = String(claim.brand || "").trim().toUpperCase();
  const size = String(claim.size || "").trim().toUpperCase();
  const amount = Number(claim.amount);

  if (!brand || !size || !Number.isFinite(amount) || amount <= 0) {
    return null;
  }

  return {
    id: String(claim.id || ""),
    name,
    brand,
    size,
    amount,
    createdAt: String(claim.createdAt || ""),
  };
}

  async loadLiveClaims(limit = 15) {
    const response = await fetch(
      `${this.claimsApi}?limit=${limit}&t=${Date.now()}`,
      { cache: "no-store" }
    );

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    const data = await response.json();

    return Array.isArray(data.claims)
      ? data.claims.map((claim) => this.normalizeLiveClaim(claim)).filter(Boolean)
      : [];
  }

  formatClaimAmount(amount) {
    const value = Number(amount);

    if (!Number.isFinite(value)) return "";
    return Number.isInteger(value) ? `$${value}` : `$${value.toFixed(2)}`;
  }

  renderLiveTicker() {
    if (!this.tickerContents?.length) return;

    this.tickerContents.forEach((track) => {
      track.replaceChildren();

      const live = document.createElement("span");
      live.textContent = "● LIVE NOW";
      track.appendChild(live);

      if (!this.liveActivity.length) {
        const waiting = document.createElement("span");
        waiting.textContent = "WAITING FOR THE NEXT CLAIM";
        track.appendChild(waiting);
        return;
      }

      this.liveActivity.forEach((claim) => {
        const item = document.createElement("span");
        item.textContent =
        `${claim.name.toUpperCase()} · ${claim.brand} / ${claim.size} · ` +
        `${this.formatClaimAmount(claim.amount)} OWED`;
        track.appendChild(item);
      });
    });
  }

  renderLiveToast(claim) {
    if (!this.toast1 || !claim) return;

    this.toast1.style.animation = "none";
    void this.toast1.offsetWidth;

    const label = document.createElement("div");
    label.className = "jb_activity_label jb_mono";

    const dot = document.createElement("span");
    dot.className = "jb_pulse_dot";

    label.appendChild(dot);
    label.appendChild(document.createTextNode(" SOMEONE JUST MADE US PAY"));

    const text = document.createElement("div");
    text.className = "jb_activity_text";

    const firstLine = document.createElement("span");
    firstLine.className = "jb_text_red";
    firstLine.textContent =
  `${claim.name.toUpperCase()} CHECKED ${claim.brand} / ${claim.size}.`;

    text.appendChild(firstLine);
    text.appendChild(document.createElement("br"));
    text.appendChild(
      document.createTextNode(
        `OFFCULTURE OWED THEM ${this.formatClaimAmount(claim.amount)}.`
      )
    );

    this.toast1.replaceChildren(label, text);
    this.toast1.style.animation =
      "jb_toastIn 0.45s cubic-bezier(0.16, 1, 0.3, 1)";
  }

  async refreshLiveActivity() {
    if (this.liveRequestInFlight) return;

    this.liveRequestInFlight = true;

    try {
      this.liveActivity = await this.loadLiveClaims(15);
      this.activityIndex = 0;
      this.renderLiveTicker();

      if (this.currentStage === 0 && this.liveActivity.length) {
        this.renderLiveToast(this.liveActivity[0]);
      }
    } catch (error) {
      console.warn("jb-discount-stage: could not load live claims", error);
    } finally {
      this.liveRequestInFlight = false;
    }
  }

  initializeActivityFeed() {
    this.refreshLiveActivity();

    if (this.activityInterval) {
      clearInterval(this.activityInterval);
    }

    if (this.liveRefreshInterval) {
      clearInterval(this.liveRefreshInterval);
    }

    this.activityInterval = setInterval(() => {
      if (this.currentStage !== 0 || !this.liveActivity.length) {
        return;
      }

      this.activityIndex =
        (this.activityIndex + 1) % this.liveActivity.length;

      this.renderLiveToast(this.liveActivity[this.activityIndex]);
    }, 3300);

    this.liveRefreshInterval = setInterval(() => {
      this.refreshLiveActivity();
    }, 30000);
  }
}

if (!customElements.get("jb-discount-stage")) {
  customElements.define("jb-discount-stage", jb_discount_stage);
}